import { BudgetAlignErrorMessages } from '@atom/types/budget';

import useBudgetAlignModal from './useBudgetAlignModal';

import classes from './budgetAlign.module.css';

const BudgetAlignModalError = () => {
  const { errorData } = useBudgetAlignModal({});

  return (
    <ul className={classes.tallyErrorContainer}>
      {[...errorData].map(error => (
        <li>{BudgetAlignErrorMessages[error]}</li>
      ))}
    </ul>
  );
};
export default BudgetAlignModalError;
